import React, { Component } from "react";
import { Formik } from "formik";
import { server } from "../../../constants";
import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  FormInput,
  FormTextarea,
  FormSelect,
} from "shards-react";
import * as actions from "../../../actions/meeting.action";
import { connect } from "react-redux";
import { httpClient } from "../../../utils/HttpClient";
import Swal from "sweetalert2";
import MeetingForm from "../MeetingForm";
import { Switch } from 'antd';
import { apiUrl } from "../../../config/index"
import moment from "moment";
import * as Yup from "yup";

const meetingValidationSchema = Yup.object().shape({
  title: Yup.string().required("กรุณากรอก ชื่อการประชุม"),
  location: Yup.string().required("กรุณากรอก สถานที่การประชุม"),
  building: Yup.string().required("กรุณากรอก อาคาร"),
  room: Yup.string().required("กรุณากรอก ห้องประชุม"),
  sequence: Yup.string().required("กรุณากรอก ครั้งที่ประชุม"),
  meetingStart: Yup.string().required("กรุณากรอก เวลาเริ่มต้น"),
  meetingEnd: Yup.string().required("กรุณากรอก เวลาสิ้นสุด"),
});

class EditMeeting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ModalInvite: false,
      ModalMeetingDocument: false,
      editable: false,
      isOwner: false
    };
    this.toggleModalInvite = this.toggleModalInvite.bind(this);
    this.toggleModalMeetingDocument = this.toggleModalMeetingDocument.bind(
      this
    );
    this.onSwitchChange = this.onSwitchChange.bind(this);
  }

  toggleModalInvite(value) {
    this.setState({
      ModalInvite: !this.state.ModalInvite,
    });
  }

  closeModalInvite() {
    this.setState({
      ModalInvite: !this.state.ModalInvite,
    });
  }

  toggleModalMeetingDocument(value) {
    this.setState({
      ModalMeetingDocument: !this.state.ModalMeetingDocument,
    });
  }

  closeModalMeetingDocument() {
    this.setState({
      ModalMeetingDocument: !this.state.ModalMeetingDocument,
    });
  }

  async componentDidMount() {
    let id = this.props.match.params.id;
    await this.props.getMeetingById(id);

    let result = localStorage.getItem("user_profile");
    const profile = JSON.parse(result);

    this.setState({
      editable: this.props.meetingReducer.result.editable === 'Y' ? true : false,
      isOwner: this.props.meetingReducer.result.createdBy === profile.id
    })
  }

  showForm = ({
    values,
    handleChange,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    handleBlur,
    errors,
    touched
  }) => {
    return (
      <div style={{ padding: 30 }}>
        <Card>
          <CardBody>
            <div className="d-flex align-items-center pb-4">
              <h5 className="font-weight-bold flex-fill mb-0 mr-3">แก้ไขการประชุม</h5>
              { this.state.isOwner && 
                (
                  <React.Fragment>
                    <span className="mr-2">การแก้ไข</span>
                    <Switch
                      defaultChecked
                      checked={this.state.editable}
                      onChange={this.onSwitchChange}
                    />
                  </React.Fragment>
                )
              }
            </div>
            <Row>
              <Col>
                <form className="form-horizontal" onSubmit={handleSubmit}>
                  <MeetingForm
                    values={values}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    handleBlur={handleBlur}
                    errors={errors}
                    touched={touched}
                  ></MeetingForm>

                  <div className="mt-5 text-right">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn btn-primary"
                      style={{ marginRight: 10, color: "white", width: 100 }}
                    >
                      บันทึก
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        this.props.history.goBack();
                      }}
                      type="Button"
                      className="btn btn-secondary"
                      style={{ color: "white", width: 100 }}
                    >
                      ย้อนกลับ
                    </button>
                  </div>
                </form>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Modal open={this.state.ModalInvite} toggle={this.toggleModalInvite}>
          <ModalHeader>เชิญประชุม</ModalHeader>
          <ModalBody>
            <Formik
              initialValues={{}}
              render={({ values, handleChange }) => (
                <React.Fragment>
                  <Row form>
                    <Col md="12" className="form-group">
                      <label>หนังสือเชิญประชุม</label>
                      <input
                        id="invitation_letter"
                        name="invitation_letter"
                        type="file"
                        onChange={(event) => {
                          setFieldValue(
                            "invitation_letter",
                            event.currentTarget.files[0]
                          );
                        }}
                        className="form-control"
                      />
                    </Col>
                  </Row>

                  <Row form>
                    <Col md="12" className="form-group">
                      <label>Email (To)</label>
                      <FormInput
                        name="name"
                        id="name"
                        onChange={handleChange}
                        value={values.name}
                      />
                    </Col>
                  </Row>

                  <Row form>
                    <Col md="12" className="form-group">
                      <label>Subject</label>
                      <FormInput
                        name="subject"
                        id="subject"
                        onChange={handleChange}
                        value={values.subject}
                      />
                    </Col>
                  </Row>

                  <Row form>
                    <Col md="12" className="form-group">
                      <label>เรียน</label>
                      <FormInput
                        name="dear"
                        id="dear"
                        onChange={handleChange}
                        value={values.dear}
                      />
                    </Col>
                  </Row>

                  <Row form>
                    <Col md="12" className="form-group">
                      <label>รายละเอียด</label>
                      <FormTextarea
                        rows="2"
                        name="detail"
                        id="detail"
                        onChange={handleChange}
                        value={values.detail}
                      />
                    </Col>
                  </Row>

                  <Row form>
                    <Col md="12" className="form-group">
                      <label>Link</label>
                      <FormInput
                        name="link"
                        id="link"
                        onChange={handleChange}
                        value={values.link}
                      />
                    </Col>
                  </Row>

                  <div className="text-right">
                    <button
                      type="button"
                      className="btn btn-primary pull-right"
                      style={{
                        marginRight: 10,
                        color: "white",
                        width: 100,
                      }}
                    >
                      บันทึก
                    </button>
                    <button
                      onClick={(e) => this.closeModalInvite()}
                      type="Button"
                      className="btn btn-danger pull-right"
                      style={{ color: "white", width: 100 }}
                    >
                      ยกเลิก
                    </button>
                  </div>
                </React.Fragment>
              )}
            />
          </ModalBody>
        </Modal>

        <Modal
          open={this.state.ModalMeetingDocument}
          toggle={this.toggleModalMeetingDocument}
        >
          <ModalHeader>เอกสารการประชุม</ModalHeader>
          <ModalBody>
            <Formik
              initialValues={{}}
              render={({ values, handleChange }) => (
                <React.Fragment>
                  <Row form>
                    <Col md="12" className="form-group">
                      <label className="text-accent">เอกสารการประชุม</label>

                      <div className="mt-2">
                        <FormSelect
                          name="pushTarget"
                          id="pushTarget"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          value={values.pushTarget}
                        >
                          {this.renderTargetOption()}
                        </FormSelect>
                      </div>
                    </Col>
                  </Row>
                  <hr />
                  <Row form>
                    {values.pushTarget === "newfile" ? (
                      <React.Fragment>
                        <Col md="6" className="form-group">
                          <div>
                            <label>Upload ไฟล์ใหม่</label>
                            <input
                              id="upload_newfile"
                              name="upload_newfile"
                              type="file"
                              onChange={(event) => {
                                setFieldValue(
                                  "upload_newfile",
                                  event.currentTarget.files[0]
                                );
                              }}
                              className="form-control"
                            />
                          </div>
                        </Col>
                      </React.Fragment>
                    ) : null}
                  </Row>

                  <Row form>
                    {values.pushTarget === "template" ? (
                      <React.Fragment>
                        <Col md="6" className="form-group">
                          <div>
                            <label>กรุณาเลือก Template</label>

                            <div className="mt-2">
                              <FormSelect
                                name="meeting_document"
                                id="meeting_document"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                value={values.meeting_document}
                              >
                                {this.renderTemplateOption()}
                              </FormSelect>
                            </div>
                          </div>
                        </Col>
                      </React.Fragment>
                    ) : null}
                  </Row>

                  <div className="text-right">
                    <button
                      type="button"
                      className="btn btn-primary pull-right"
                      style={{
                        marginRight: 10,
                        color: "white",
                        width: 100,
                      }}
                    >
                      บันทึก
                    </button>
                    <button
                      onClick={(e) => this.closeModalMeetingDocument()}
                      type="Button"
                      className="btn btn-danger pull-right"
                      style={{ color: "white", width: 100 }}
                    >
                      ยกเลิก
                    </button>
                  </div>
                </React.Fragment>
              )}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  };

  renderTargetOption() {
    let optionList = [
      {
        value: "",
        label: "กรุณาเลือกชนิดของเอกสาร",
      },
      {
        value: "newfile",
        label: "New File",
      },
      {
        value: "template",
        label: "Template",
      },
    ];

    let optionElements = optionList.map((item) => (
      <option value={item.value} key={item.value}>
        {item.label}
      </option>
    ));

    return optionElements;
  }

  renderTemplateOption() {
    let optionList = [
      {
        value: "",
        label: "กรุณาเลือก Template",
      },
      {
        value: "1",
        label: "สำนัก...",
      },
      {
        value: "2",
        label: "สำนัก...",
      },
    ];

    let optionElements = optionList.map((item) => (
      <option value={item.value} key={item.value}>
        {item.label}
      </option>
    ));

    return optionElements;
  }

  async onSwitchChange(checked) {
    const token = localStorage.getItem("token");
    this.setState({editable: checked})

    let response = await httpClient.patch(
      server.MEETING_URL + "/" + `${this.props.match.params.id}`,
      JSON.stringify({
        id: this.props.match.params.id,
        editable: checked ? 'Y' : 'N'
      }),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
      }
    );
  }

  render() {
    const { result } = this.props.meetingReducer;

    if (result) {
      result.file = ''

      if (result.meetingStart) {
        result.meetingDate = result.meetingStart;
        
        const meetingMonth = new Date(result.meetingStart).getMonth()
        let meetingYear = new Date(result.meetingStart).getFullYear()

        // if(meetingMonth >= 10)  {
        //   meetingYear += 1
        // }

        result.year = meetingYear + 543
      }
    }
    return (
      <React.Fragment>
        { result && (
          <Formik
            enableReinitialize
            initialValues={result ? result : {}}
            onSubmit={async (values, { setSubmitting }) => {
              var result = localStorage.getItem("user_profile");
              const displayName = JSON.parse(result).displayName;
              const token = localStorage.getItem("token");

              values.meetingDate = new Date(values.meetingDate)
              values.meetingStart = new Date(values.meetingStart)
              values.meetingEnd = new Date(values.meetingEnd)
              
              const meetingDate = values.meetingDate.getDate()
              const meetingMonth = values.meetingDate.getMonth()
              const meetingYear = values.meetingDate.getFullYear()

              values.meetingStart.setDate(meetingDate)
              values.meetingStart.setMonth(meetingMonth)
              values.meetingStart.setFullYear(meetingYear)
              values.meetingEnd.setDate(meetingDate)
              values.meetingEnd.setMonth(meetingMonth)
              values.meetingEnd.setFullYear(meetingYear)

              const params = {
                id: values.id,
                title: values.title,
                location: values.location,
                building: values.building,
                room: values.room,
                sequence: values.sequence,
                meetingStart: values.meetingStart,
                meetingEnd: values.meetingEnd,
                updatedBy: displayName,
                updatedAt: new Date(),
                rootFolder: values.rootFolder,
                password: values.password
              }

              let response = await httpClient.patch(
                server.MEETING_URL + "/" + `${values.id}`,
                JSON.stringify(params),
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                  },
                }
              );

              if (response.status === 201 || response.status === 200) {
                setSubmitting(false);
                Swal.fire({
                  icon: "success",
                  text: "แก้ไขข้อมูลการประชุมเรียบร้อบแล้ว",
                  timer: 3000,
                });
                // this.props.history.push(`/meeting`);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  timer: 2500,
                });
              }
            }}
          >
            {(props) => this.showForm(props)}
          </Formik>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ meetingReducer }) => ({ meetingReducer });

const mapDispatchToProps = {
  ...actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditMeeting);
